import { render, staticRenderFns } from "./ChatWindowManager.vue?vue&type=template&id=1e4a3651"
import script from "./ChatWindowManager.vue?vue&type=script&lang=js"
export * from "./ChatWindowManager.vue?vue&type=script&lang=js"
import style0 from "./ChatWindowManager.vue?vue&type=style&index=0&id=1e4a3651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports